import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { IonicStorageModule } from '@ionic/storage';
import { FormsModule } from '@angular/forms'
import { HttpModule } from '@angular/http'
import { File } from "@ionic-native/file";
//import { Camera } from '@ionic-native/camera';
//import { Camera, CameraResultType } from '@capacitor/camera';

import { WhiskyWall } from './app.component';

import { ContactPage } from '../pages/contact/contact';
import { DistilleriesPage } from '../pages/distilleries/distilleries';
import { ShelvesPage } from '../pages/shelves/shelves';
import { RatingsPage } from '../pages/ratings/ratings';
import { TabsPage } from '../pages/tabs/tabs';
import { ListPage } from '../pages/list/list';
import { BasketPage } from '../pages/basket/basket';
import { BottlersPage } from '../pages/bottlers/bottlers';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { NewBottlerPage } from '../pages/newBottler/newBottler';
import { NewRatingPage } from '../pages/newRating/newRating';
import { NewDistilleryPage } from '../pages/newDistillery/newDistillery';
import { NewShelfPage } from '../pages/newShelf/newShelf';
import { NewWhiskyPage } from '../pages/newWhisky/newWhisky';
import { NewWhiskySelectPage } from '../pages/newWhiskySelect/newWhiskySelect';
import { ShowWhiskyPage } from '../pages/showWhisky/showWhisky';
import { User } from '../providers/providers';
import { Cognito } from '../providers/aws.cognito';
import { DynamoDB } from '../providers/aws.dynamodb';
import { LoginPage } from '../pages/login/login';
import { SignupPage } from '../pages/signup/signup';
import { ConfirmPage } from '../pages/confirm/confirm';
import { SublistPage } from '../pages/sublist/sublist';
import { ResetPage } from '../pages/reset/reset';
import { AppRate } from '@ionic-native/app-rate';
import { Network } from '@ionic-native/network';
import { AboutPage } from '../pages/about/about';
import { HomePage } from '../pages/home/home';
//import { Zeroconf } from '@ionic-native/zeroconf';
//import { AppVersion } from '@ionic-native/app-version';

//import { AngularFireModule } from 'angularfire2';
//import { AngularFireDatabaseModule } from 'angularfire2/database';

export const firebaseConfig  = {
  apiKey: "AIzaSyCa4zOiUGKl922jj91GvAcfGue2zdlq974",
  authDomain: "whiskywall-fc2f1.firebaseapp.com",
  databaseURL: "https://whiskywall-fc2f1.firebaseio.com",
  projectId: "whiskywall-fc2f1",
  storageBucket: "whiskywall-fc2f1.appspot.com",
  messagingSenderId: "682905694292"
};

@NgModule({
  declarations: [
    WhiskyWall,
    DistilleriesPage,
    ShelvesPage,
    RatingsPage,
    ContactPage,
    TabsPage,
    ListPage,
    BasketPage,
    BottlersPage,
    NewBottlerPage,
    NewRatingPage,
    NewShelfPage,
    NewDistilleryPage,
    NewWhiskyPage,
    NewWhiskySelectPage,
    ShowWhiskyPage,
    LoginPage,
    SignupPage,
    ConfirmPage,
    SublistPage,
    ResetPage,
    AboutPage,
    HomePage,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    IonicModule.forRoot(WhiskyWall),
    IonicStorageModule.forRoot(),
    //AngularFireModule.initializeApp(firebaseConfig),
    //AngularFireDatabaseModule

  ],
  bootstrap: [IonicApp],
  entryComponents: [
    WhiskyWall,
    ContactPage,
    DistilleriesPage,
    ShelvesPage,
    RatingsPage,
    TabsPage,
    ListPage,
    BasketPage,
    BottlersPage,
    NewBottlerPage,
    NewRatingPage,
    NewDistilleryPage,
    NewShelfPage,
    NewWhiskyPage,
    NewWhiskySelectPage,
    ShowWhiskyPage,
    LoginPage,
    SignupPage,
    ConfirmPage,
    SublistPage,
    ResetPage,

  ],
  providers: [
    StatusBar,
    SplashScreen,
    File,
    User,
    Cognito,
    DynamoDB,
    AppRate,
    Network,
    {provide: ErrorHandler, useClass: IonicErrorHandler}
  ]
})
export class AppModule {}

declare var AWS;
AWS.config.customUserAgent = AWS.config.customUserAgent + ' Ionic';



// WEBPACK FOOTER //
// ./src/app/app.module.ts